// extracted by mini-css-extract-plugin
export default {"previewReadOnly":"style_previewReadOnly__b7l42"};